<script>
  import { getTextData } from "../api/getTextData";
  import { toPairs, pipe, map } from "rambda";
  import GoBackButton from "./GoBackButton.svelte";

  export let pathToFile = "";

  const convertToAO = pipe(
    toPairs,
    map(([_, secondItem]) => secondItem)
  ); //AO = Array of Objects

  let promise = getTextData(pathToFile, convertToAO);
</script>

{#await promise then textDataArr}
  <GoBackButton />
  <div class="wrapper">
    {#each textDataArr as item}
      <h1>{item.BIG_HEADING || ""}</h1>
      <h2>{item.MEDIUM_HEADING || ""}</h2>
      <p>{item.TEXT || ""}</p>
      {#if item.LIST}
        <ul>
          {#each item.LIST as listItem}
            <li>{listItem.TEXT || ""}</li>
          {/each}
        </ul>
      {/if}
    {/each}
  </div>
{/await}

<style>
  .wrapper {
    padding: 16px;
  }

  h1 {
    font-family: Nunito Sans;
    font-style: normal;
    font-weight: 800;
    font-size: 32px;
    line-height: 49px;

    color: var(--primary-color);

    margin-top: 16px;
  }

  h2 {
    font-family: Nunito Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 26px;
    line-height: 49px;

    color: #3b3d3ce3;

    margin-top: 16px;
  }
  p {
    font-family: Nunito Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 190%;

    color: #6e6e6e;

    margin-top: 16px;
  }

  ul {
    margin: 0;
  }
  li {
    margin: 0;
    list-style: none;
    font-family: Nunito Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 190%;

    color: #6e6e6e;
    margin-top: 4px;
  }

  li::before {
    content: "✅ ";
  }
</style>
